import React from 'react';
import { ProductCard } from './ProductCarousel';

const BestSellersSection = ({ products, onAdd }) => {
  return (
    <section className="py-14 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="text-amber-600 text-xs uppercase tracking-[0.3em] font-semibold mb-2">Best Sellers</div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Prinde acum promoțiile momentului
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Fii cu ochii pe cele mai moderne și inovative produse din colecția noastră.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} onAdd={onAdd} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestSellersSection;
